var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3181 18.5933L21.3281 24.2773C21.3394 24.3442 21.33 24.413 21.3012 24.4744C21.2723 24.5359 21.2254 24.5871 21.1667 24.6211C21.108 24.6552 21.0403 24.6705 20.9726 24.6651C20.905 24.6596 20.8406 24.6336 20.7881 24.5906L18.4014 22.7993C18.2862 22.7132 18.1462 22.6667 18.0024 22.6667C17.8586 22.6667 17.7186 22.7132 17.6034 22.7993L15.2127 24.5899C15.1603 24.6329 15.096 24.6588 15.0284 24.6643C14.9608 24.6698 14.8932 24.6545 14.8345 24.6205C14.7758 24.5865 14.7289 24.5355 14.7 24.4742C14.6711 24.4128 14.6616 24.3441 14.6727 24.2773L15.6821 18.5933",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.3333C20.2091 19.3333 22 17.5424 22 15.3333C22 13.1241 20.2091 11.3333 18 11.3333C15.7909 11.3333 14 13.1241 14 15.3333C14 17.5424 15.7909 19.3333 18 19.3333Z",
    stroke: "#003D7A",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthical);
export default __webpack_public_path__ + "static/media/ethical.6ba5de3b4032526abe83e870f2e67f9c.svg";
export { ForwardRef as ReactComponent };